import { render } from "./carruselComponente-3.vue?vue&type=template&id=24d399dc&scoped=true"
import script from "./carruselComponente-3.vue?vue&type=script&lang=js"
export * from "./carruselComponente-3.vue?vue&type=script&lang=js"

import "./carruselComponente-3.vue?vue&type=style&index=0&id=24d399dc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24d399dc"]])

export default __exports__